// extracted by mini-css-extract-plugin
module.exports = {"interface":"SettingInterfacePptx_interface__2DUgI","contents":"SettingInterfacePptx_contents__1_UEK"};